import { Store } from '../../ReduxStorage/Store';
import { initialiseFromDom } from '../../ReduxStorage/Initialisers';

// Initialise the store
initialiseFromDom(Store.dispatch, Store.getState);
